<template>
  <ion-page>
    <ion-header class="ion-no-border" translucent>
      <ion-toolbar class="-not-fixed">
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
        <ion-button
          @click="$store.commit('setOpenMenu', true)"
          slot="end"
          fill="clear"
          size="large"
          ><ion-icon
            slot="icon-only"
            :src="require('@lib/assets/icons/menu.svg')"
            size="large"
          ></ion-icon
        ></ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen class="ion-padding">
      <ion-grid>
        <h1>Roodie.Safe</h1>
        <ion-list>
          <ion-item button router-link="/roodie-checks">
            <ion-label>Roodie.Checks</ion-label>
            <ion-icon
              color="primary"
              :icon="documentTextOutline"
              slot="start"
            ></ion-icon>
          </ion-item>
          <ion-item button router-link="/termine-aerzte">
            <ion-label>Termine & Ärzte</ion-label>
            <ion-icon
              color="primary"
              :icon="calendarOutline"
              slot="start"
            ></ion-icon>
          </ion-item>
          <ion-item button router-link="/befunde">
            <ion-label>Befunde & Co</ion-label>
            <ion-icon
              color="primary"
              :icon="documentAttachOutline"
              slot="start"
            ></ion-icon>
          </ion-item>
          <ion-item button router-link="/nachrichten">
            <ion-label>Nachrichten</ion-label>
            <ion-icon
              color="primary"
              :icon="chatboxOutline"
              slot="start"
            ></ion-icon>
          </ion-item>
        </ion-list>
      </ion-grid>
      <add-fab></add-fab>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  // IonTitle,
  IonButtons,
  IonContent,
  IonList,
  // IonListHeader,
  IonItem,
  IonLabel,
  // IonNote,
  IonButton,
  IonIcon,
  //   IonText,
  IonGrid,
  //   IonRow,
  //   IonCol,
  IonBackButton,
} from "@ionic/vue";
import {
  chevronBack,
  documentTextOutline,
  calendarOutline,
  documentAttachOutline,
  chatboxOutline,
} from "ionicons/icons";
import AddFab from "@/components/AddFab";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    // IonTitle,
    IonButtons,
    IonContent,
    IonList,
    // IonListHeader,
    IonItem,
    IonLabel,
    // IonNote,
    IonButton,
    IonIcon,
    // IonText,
    IonGrid,
    // IonRow,
    // IonCol,
    IonBackButton,
    AddFab,
  },
  methods: {},
  setup() {
    return {
      chevronBack,
      documentTextOutline,
      calendarOutline,
      documentAttachOutline,
      chatboxOutline,
    };
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
